import has from 'lodash/has';
import {
  RESET_PASSWORD_FORM_LOADED,
  RESET_PASSWORD_REQUEST,
  RESET_PASSWORD_SUCCESS,
  RESET_PASSWORD_FAILURE,
  SET_PASSWORD_FORM_LOADED,
  SET_PASSWORD_REQUEST,
  SET_PASSWORD_SUCCESS,
  SET_PASSWORD_FAILURE,
  LOGOUT_COMPLETE,
} from '../../constants/actionTypes';
import { RESET_PASSWORD_ERROR, SET_PASSWORD_ERROR } from '../../constants/MessageConstants';

const initialState = {
  emailSent: false,
  error: null,
  passwordReset: false,
  passwordResetError: null,
};

const resetPasswordReducer = (state = initialState, action) => {
  switch (action.type) {
    case RESET_PASSWORD_FORM_LOADED:
    case RESET_PASSWORD_REQUEST:
    case SET_PASSWORD_FORM_LOADED:
    case SET_PASSWORD_REQUEST:
    case LOGOUT_COMPLETE:
      return initialState;

    case RESET_PASSWORD_SUCCESS:
      return {
        ...state,
        emailSent: true,
        error: null,
      };

    case RESET_PASSWORD_FAILURE: {
      let errorMessage =
        has(action, 'error') && action.error !== 'Unauthorized'
          ? action.error
          : RESET_PASSWORD_ERROR;
      return {
        ...state,
        emailSent: false,
        error: errorMessage,
      };
    }

    case SET_PASSWORD_SUCCESS:
      return {
        ...state,
        passwordReset: true,
        passwordResetError: null,
      };

    case SET_PASSWORD_FAILURE: {
      let errorMessage = has(action, 'message') ? action.message : SET_PASSWORD_ERROR;
      return {
        ...state,
        passwordReset: false,
        passwordResetError: errorMessage,
      };
    }

    default:
      return state;
  }
};

export default resetPasswordReducer;
